import React, { useEffect } from "react";
import "styles/events.css";
import Nav from "components/nav/Navbar";
import Events from "components/events/Event";

export default function EventsPage() {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }, []);

  return (
    <div className="w-full min-h-screen bg-secondary_black">
      <Nav />

      <Events />
    </div>
  );
}
